/**
 * Lo pendiente, ya listo para pintar · 13-10-2026
 *
 * El servidor manda códigos con su cuenta (`GET /clubs/{club}/today`,
 * `GET /admin/pending`); cada lado los traduce a esto con su catálogo
 * (`club/pendientes.ts`, `backoffice/pendientes.ts`), que es quien conoce sus
 * rutas y su forma de decir las cosas. Lo de aquí solo pinta.
 */
import type { NombreDeIcono } from '@/shared/ui/Icono';

export type Gravedad = 'high' | 'medium' | 'low';

export interface Pendiente {
  readonly clave: string;
  readonly gravedad: Gravedad;
  readonly icono: NombreDeIcono;
  readonly titulo: string;
  readonly detalle: string;
  /** El verbo del botón: «Firmarlo», «Contestar», «Ver quién debe». */
  readonly accion: string;
  /**
   * La pantalla donde se actúa. **Sin ella, la tarjeta solo informa**: el contrato
   * sin firmar, para el administrativo, que no lo firma ni puede abrir su pantalla.
   * Un botón que lleva a una pantalla que te devuelve es peor que no tener botón.
   */
  readonly destino?: string | undefined;
}

export const urgentes = (lista: readonly Pendiente[]) =>
  lista.filter((p) => p.gravedad === 'high');
